import React from "react";

const Link = ({ href, children }) => (
  <a href={href} target="_blank">{children}</a>
);

export default Link;